<template>
    <div>
        <h1 class="mb-8 font-bold text-3xl">Aspirantes</h1>
        <div class="mb-6  items-center">
            <header @click="show=!show" class="flex items-center  cursor-pointer select-none">
                <div class="rounded-full border border-grey w-7 h-7">
                    <!-- icon by feathericons.com -->
                    <svg aria-hidden="true" class="" data-reactid="266" fill="none" height="24" stroke="#606F7B" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                        <polyline points="6 9 12 15 18 9">
                        </polyline>
                    </svg>
                </div>
                <span class="text-grey-darkest font-medium text-xl">
                    Ver Filtros
                </span>

            </header>

            <div v-show="show" class="border px-2 py-1 my-3 ">
                <form id="filtro_form"><!-- @submit.prevent="filtrar" -->
                    <div class="p-6 -mr-4 -mb-6 flex flex-wrap">
                        <text-input v-model="form.fullsearch" class="pr-6 pb-8 w-full lg:w-1/2" label="Busqueda General( Nombre, Apellido, Dni o Email )" />
                        <text-input v-model="form.numero_inscripcion"  class="pr-6 pb-8 w-full lg:w-1/2" label="Numero Inscripcion" />
                        <div class="pr-6 pb-8 w-full lg:w-1/2">
                            <label class="form-label font-bold" >Fecha de Inscripcion desde - hasta:</label>
                            <!-- <el-date-picker
                            v-model="form.fecha_inscripcion"
                            type="daterange"
                            range-separator="-"
                            start-placeholder="Desde"
                            end-placeholder="Hasta">
                            </el-date-picker> -->
                            <el-date-picker
                                v-model="form.fecha_inscripcion"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="-"
                                start-placeholder="Desde"
                                end-placeholder="Hasta"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                        </div>
                        <div class="pr-6 pb-8 w-full lg:w-1/2" >
                            <div >
                                <span class="text-gray-700 font-bold">Certificado De Discapacidad:</span>
                                <label class="inline-flex items-center ml-2">
                                    <input type="radio" class="form-radio" name="accountType" value="SI" v-model="form.certificado_de_discapacidad">
                                    <span class="ml-2">Si</span>
                                </label>
                                <label class="inline-flex items-center ml-2">
                                    <input type="radio" class="form-radio" name="accountType" value="NO" v-model="form.certificado_de_discapacidad">
                                    <span class="ml-2">No</span>
                                </label>
                                <label class="inline-flex items-center ml-2">
                                    <input type="radio" class="form-radio" name="accountType" value="" v-model="form.certificado_de_discapacidad" >
                                    <span class="ml-2">Todo</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <button class="ml-8 mb-2 btn-login" tabindex="-1" type="button" @click="filtrar" aria-label="Buscar">Buscar</button>
                    <button class="ml-8 mb-2 btn-login" tabindex="-1" type="button" @click="resetear" aria-label="Borrar Busqueda">Borrar Busqueda</button>
                    <a @click="exportarExcel" class="ml-8 mb-2 btn-login" aria-label="Exportar Excel">
                        <span>Exportar</span> <span class="hidden md:inline">Excel</span>
                    </a>
                </form>
            </div>


        </div>


        <div class="bg-white rounded-md shadow overflow-x-auto font-bold">
            <!-- <table class="w-full whitespace-nowrap"> -->
                <table class="" aria-labelledby="Listado de Aspirante">
                <tr class="text-left font-bold">
                    <th class="px-6 pt-6 pb-4" aria-labelledby="Botones de acciones">Acciones</th>
                    <th class="px-6 pt-6 pb-4" aria-labelledby="Numero de inscripción">Nro. de Inscripción</th>
                    <th class="px-6 pt-6 pb-4" aria-labelledby="Fecha de inscripción">Fecha de Inscripción</th>
                    <th class="px-6 pt-6 pb-4" aria-labelledby="Nombre">Nombre</th>
                    <th class="px-6 pt-6 pb-4" aria-labelledby="Apellido">Apellido</th>
                    <th class="px-6 pt-6 pb-4" aria-labelledby="Tipo de Documento">Tipo de Documento</th>
                    <th class="px-6 pt-6 pb-4" aria-labelledby="Numero de Documento">Nro. de Documento</th>
                    <th class="px-6 pt-6 pb-4" aria-labelledby="Cuit">Cuit</th>
                    <th class="px-6 pt-6 pb-4" aria-labelledby="Email">Email</th>
                    <th class="px-6 pt-6 pb-4" aria-labelledby="Certificado de Discapacidad">Certificado de Discapacidad</th>
                </tr>
                <tr v-for="aspirante in aspirantes.data" :key="aspirante.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center" :href="route(editRoute, aspirante.id)" tabindex="-1">
                            <button type="button" class="btn-login ml-auto" aria-label="Editar Aspirante">Editar</button>
                        </inertia-link>
                    </td>
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route(linkRoute, aspirante.id)">
                            {{ aspirante.numero_inscripcion }}
                        </inertia-link>
                    </td>
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route(linkRoute, aspirante.id)">
                            {{ aspirante.fecha_inscripcion}}
                        </inertia-link>
                    </td>
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route(linkRoute, aspirante.id)">
                            {{ aspirante.nombre }}
                        </inertia-link>
                    </td>
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center" :href="route(linkRoute, aspirante.id)" tabindex="-1">
                            {{ aspirante.apellido }}
                        </inertia-link>
                    </td>
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center" :href="route(linkRoute, aspirante.id)" tabindex="-1">
                            {{ aspirante.tipo_documento }}
                        </inertia-link>
                    </td>
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center" :href="route(linkRoute, aspirante.id)" tabindex="-1">
                            {{ aspirante.numero_documento }}
                        </inertia-link>
                    </td>
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center" :href="route(linkRoute, aspirante.id)" tabindex="-1">
                            {{ aspirante.cuit_cuil }}
                        </inertia-link>
                    </td>
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center" :href="route(linkRoute, aspirante.id)" tabindex="-1">
                            {{ aspirante.correo_electronico }}
                        </inertia-link>
                    </td>
                        <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center" :href="route(linkRoute, aspirante.id)" tabindex="-1">
                            {{ aspirante.certificado_de_discapacidad }}
                        </inertia-link>
                    </td>

                </tr>
            </table>
        </div>

        <pagination class="mt-6 font-bold text-black" :links="aspirantes.links" />

    </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from "../../Shared/SelectInput";
import AsignacionAspirante from '../AsignacionAspirante/Formulario';
import moment from 'moment';
import axios from 'axios'




export default {
    metaInfo: { title: 'Aspirantes' },

    components: {
        SelectInput,
        Icon,
        Pagination,
        SearchFilter,
        TextInput,
        LoadingButton,
        AsignacionAspirante,
    },
    filters:{
        fecha(value){
            return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY');
        },
    },
    layout: Layout,
    props: {
        aspirantes: Object,
        lista_estudios: Object,
    },
    data() {
        return {
            show: false,
            linkRoute : 'aspirantes.view',
            editRoute : 'aspirantes.edit',
            form: {
                nombre: '',
                apellido:'',
                certificado_de_discapacidad:'',
                //experiencia_judicial:'',
                //estudio_id:'',
                numero_inscripcion:'',
                fecha_inscripcion:'',
                //auxiliar:'',
                // auxiliar_de_servicio:'',
                fullsearch: '',
            },
            asignacion:false,
            aspirante:'',
            pickerOptions: {
                shortcuts: [{
                    text: 'Ultima Semana',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: 'Ultimo mes',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: 'Ultimo Año',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },

        }
    },
    mounted(){
       // console.log("lista",this);
        // console.log("estoy mounted")
        // console.log(this.aspirantes)

    },
    computed: {
        url_export: function () {
           return '/exportExcel'
           ///?params=' + JSON.stringify(this.form);
        },
    },
    methods: {

        exportarExcel (){
          //cargo el loading
          this.loader = 'loading'
                const params = {
                    params: JSON.stringify(this.form)
                };


          axios.get(this.url_export, {params, responseType: 'blob'}).then(response => {
              const name = 'Aspirante.xlsx';
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', name); //or any other extension
              document.body.appendChild(link);
              link.click();
          }).catch(error => {
              console.log(error);
          })

        },
        asigna(aspirante){
            this.aspirante = aspirante
            this.asignacion = true;
        },
        closeAsignacionDialog(){
            this.asignacion = false;
        },
        filtrar() {
            //this.form.get(this.route('users.store'))
          //  console.log('filter:',pickBy(this.form));
            this.$inertia.get(this.route('aspirantes.list'), pickBy(this.form), { preserveState: true, replace :true })
        },
        /*
        exportarExcel() {
            this.$inertia.get(this.route('aspirantes.exportExcel'),pickBy(this.form), { preserveState: true });
            //console.log("exportar excel")
        },*/
        resetear(){
            for (const prop in this.form) {
                this.form[prop] = '';
            };

            // el select no se limpia con la propiedad del form
            this.$refs.estudio_id_select.selected = undefined;
            this.filtrar();
        }
    },

}
</script>
